var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { attrs: { id: "ai-usage" } }, [
    _c("h6", [_vm._v("E. AI Usage Declaration")]),
    _vm._v(" "),
    _vm.aiPriorDeclared
      ? _c(
          "p",
          { staticClass: "ai-prior-summary" },
          [
            _vm._v("Your declared AI usage for previously submitted versions:"),
            _c("br"),
            _c("br"),
            _vm._l(_vm.aiPriorSummaryLines, function (line, index) {
              return _c("span", { key: index }, [
                _vm._v(_vm._s(line)),
                _c("br"),
              ])
            }),
          ],
          2
        )
      : _c("p", { staticClass: "ai-no-prior-usage" }, [
          _vm._v(
            "No AI usage has been declared for previously submitted versions."
          ),
        ]),
    _vm._v(" "),
    _c(
      "label",
      { attrs: { id: "aiUsageLabel" } },
      [
        _vm.aiPriorDeclared
          ? [
              _vm._v("Did you or any coauthors use any "),
              _c("strong", [_vm._v("additional AI tools")]),
              _vm._v(" for any "),
              _c("strong", [_vm._v("additional purposes")]),
              _vm._v(" for this revision?"),
            ]
          : [
              _vm._v(
                "Did you or any coauthors use generative AI tools for this revision?"
              ),
            ],
        _vm._v(" "),
        _c("span", { staticClass: "required" }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { role: "radiogroup", "aria-labelledby": "aiUsageLabel" } },
      [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.aiUsage,
                expression: "aiUsage",
              },
            ],
            attrs: { type: "radio", value: "no" },
            domProps: { checked: _vm._q(_vm.aiUsage, "no") },
            on: {
              change: [
                function ($event) {
                  _vm.aiUsage = "no"
                },
                function ($event) {
                  return _vm.onChange()
                },
              ],
            },
          }),
          _vm._v(" No"),
        ]),
        _c("br"),
        _vm._v(" "),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.aiUsage,
                expression: "aiUsage",
              },
            ],
            attrs: { type: "radio", value: "yes" },
            domProps: { checked: _vm._q(_vm.aiUsage, "yes") },
            on: {
              change: [
                function ($event) {
                  _vm.aiUsage = "yes"
                },
                function ($event) {
                  return _vm.onChange()
                },
              ],
            },
          }),
          _vm._v(" Yes"),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.aiPriorDeclared && _vm.aiUsage === "yes"
      ? _c("p", { staticClass: "ai-info-text" }, [
          _vm._v(
            "Please select the AI tools used and/or the purpose of use before submitting."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.errors && _vm.errors["aiUsage"]
      ? _c("p", { staticClass: "ai-error-text" }, [
          _vm._v(_vm._s(_vm.errors["aiUsage"][0])),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.aiUsage === "yes"
      ? _c(
          "div",
          { attrs: { id: "aiDetailsSection" } },
          [
            _vm._l(_vm.aiQuestionGroups, function (group, groupId, index) {
              return _c(
                "div",
                { key: groupId, staticClass: "ai-question-group" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(index + 1) +
                        ". " +
                        _vm._s(group.title) +
                        " (select all that apply)"
                    ),
                    !_vm.aiPriorDeclared
                      ? _c("span", { staticClass: "required" })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm._l(group.questions, function (question) {
                    return _c(
                      "div",
                      {
                        key: question.question_id,
                        staticClass: "ai-question-option",
                        class: {
                          declared: _vm.isPreviouslyDeclared(
                            question.question_id
                          ),
                        },
                      },
                      [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedAIQuestions,
                                expression: "selectedAIQuestions",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.isPreviouslyDeclared(
                                question.question_id
                              ),
                            },
                            domProps: {
                              value: question.question_id,
                              checked: Array.isArray(_vm.selectedAIQuestions)
                                ? _vm._i(
                                    _vm.selectedAIQuestions,
                                    question.question_id
                                  ) > -1
                                : _vm.selectedAIQuestions,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.selectedAIQuestions,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = question.question_id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectedAIQuestions = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectedAIQuestions = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectedAIQuestions = $$c
                                  }
                                },
                                function ($event) {
                                  return _vm.onChange()
                                },
                              ],
                            },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(question.title) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        question.question_type === 2 &&
                        _vm.selectedAIQuestions.includes(question.question_id)
                          ? _c("div", { staticClass: "ai-freetext-input" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.aiFreetextValues[
                                        question.question_id
                                      ],
                                    expression:
                                      "aiFreetextValues[question.question_id]",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  placeholder: "Please specify...",
                                  "aria-label": question.title,
                                },
                                domProps: {
                                  value:
                                    _vm.aiFreetextValues[question.question_id],
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onChange()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.aiFreetextValues,
                                      question.question_id,
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v(
                _vm._s(_vm.aiAcknowledgmentNumber) + ". AI Usage Acknowledgment"
              ),
              _c("span", { staticClass: "required" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ai-acknowledgment-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.aiAcknowledgment,
                    expression: "aiAcknowledgment",
                  },
                ],
                attrs: { type: "checkbox", id: "aiAcknowledgment" },
                domProps: {
                  checked: Array.isArray(_vm.aiAcknowledgment)
                    ? _vm._i(_vm.aiAcknowledgment, null) > -1
                    : _vm.aiAcknowledgment,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.aiAcknowledgment,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.aiAcknowledgment = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.aiAcknowledgment = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.aiAcknowledgment = $$c
                      }
                    },
                    function ($event) {
                      return _vm.onChange()
                    },
                  ],
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _vm.errors && _vm.errors["aiAcknowledgment"]
              ? _c("p", { staticClass: "ai-error-text" }, [
                  _vm._v(_vm._s(_vm.errors["aiAcknowledgment"][0])),
                ])
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "aiAcknowledgment" } }, [
      _vm._v(
        "\n                I confirm that the outputs of all tools used in the preparation of this manuscript were verified by the authors who take full responsibility for the final content of the manuscript. This statement is made in accordance with "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://support.jmir.org/hc/en-us/articles/13387268671771-Do-you-allow-the-use-of-ChatGPT-or-other-generative-language-models-and-how-should-this-be-reported",
            target: "_blank",
          },
        },
        [_vm._v("JMIR Publications Policy on the use of Generative AI")]
      ),
      _vm._v("."),
      _c("span", { staticClass: "required" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }